<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { TrashIcon, PlusIcon, InformationCircleIcon } from '@heroicons/vue/24/outline'

const props = defineProps(['graduations']);

const graduations = ref(JSON.parse(props.graduations).length ? JSON.parse(props.graduations) : [{ 'type': '', 'start': '', 'end': '', 'active': false, 'description': '' }]);

const addGraduation = () => {
    graduations.value.push({ 'type': '', 'start': '', 'end': '', 'active': false, 'description': '' });
}

const deleteGraduation = (index) => {
    graduations.value.splice(index, 1);
}

const graduationsValue = computed(() => {
    return graduations.value.filter(graduation => graduation.type);
});
</script>

<template>
    <div class="md:tw-col-span-2 tw-py-5 tw-space-y-5 tw-max-w-3xl ">
        <div v-for="(graduation, index) in graduations" :key="index"
            class="tw-grid tw-grid-cols-1 tw-gap-x-6 tw-gap-y-4 sm:tw-grid-cols-6 tw-rounded tw-border tw-p-5 tw-relative tw-group tw-bg-gray-100">

            <h3 class="sm:tw-col-span-6">Meine Stationen</h3>

            <a class="tw-text-red-800 tw-bg-red-600/10 hover:tw-bg-red-600/20 hover:tw-text-red-900 tw-rounded-full tw-p-2 tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-absolute tw-right-5 tw-top-3 tw-invisible group-hover:tw-visible"
                @click="deleteGraduation(index)">
                <TrashIcon class="tw-h-3.5 tw-w-auto" aria-hidden="true" />
            </a>

            <div class="sm:tw-col-span-2">
                <label :for="'graduation-' + index + '-type'">Art *</label>
                <select v-model="graduation.type" :id="'graduation-' + index + '-type'" class="custom-select" required>
                    <option value="">Auswählen...</option>
                    <option value="0">Ausgeübter Beruf</option>
                    <option value="1">Berufsausbildung</option>
                    <option value="2">Studium</option>
                    <option value="3">Qualifikation</option>
                    <option value="4">Schulabschluss</option>
                    <option value="5">Weiterbildung</option>
                    <option value="6">BFD/FSJ</option>
                </select>
            </div>

            <div class="sm:tw-col-span-4">
                <label :for="'graduation-' + index + '-description'">Beschreibung</label>
                <input v-model="graduation.description" type="text" :id="'graduation-' + index + '-description'"
                    placeholder="Beschreibung" class="form-control">
            </div>

            <div class="sm:tw-col-span-3">
                <label :for="'graduation-' + index + '-start'">Von *</label>
                <input v-model="graduation.start" :id="'graduation-' + index + '-start'" type="month"
                    class="form-control" required placeholder="YYYY-MM">
                <small>
                    <InformationCircleIcon class="tw-w-4 tw-h-auto" /> Deine Stationen werden in deinem Profil
                    automatisch chronologisch sortiert.
                </small>
            </div>

            <div class="sm:tw-col-span-3">
                <label :for="'graduation-' + index + '-end'">Bis</label>
                <input v-model="graduation.end" :id="'graduation-' + index + '-end'" type="month" class="form-control"
                    :disabled="graduation.active" placeholder="YYYY-MM">

                <div class="tw-text-right tw-mt-2">
                    <input v-model="graduation.active" class="form-check-input" type="checkbox"
                        :id="'graduation-' + index + '-active'">
                    <label class="form-check-label" :for="'graduation-' + index + '-active'">
                        bis Heute
                    </label>
                </div>
            </div>
        </div>
        <div @click="addGraduation"
            class="sm:tw-col-span-6 tw-bg-gray-100 hover:tw-bg-gray-200 tw-p-2 tw-rounded tw-text-sm tw-flex tw-items-center tw-justify-center tw-gap-1 tw-cursor-pointer tw-mt-4">
            Weitere Station hinzufügen
            <PlusIcon class="tw-w-3" />
        </div>

        <input name="graduations" class="tw-hidden" :value="JSON.stringify(graduationsValue)">
    </div>
</template>
